import { User } from '@app/user/interfaces/user';
import { createAction, props } from '@ngrx/store';
import * as actions from '../constants/actions.constants';

export const setInviteData = createAction(actions.setInviteData, props<{ inviteData: User }>());
